import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LineItem } from './LineItem';
import { LineItemType } from './LineItemType';
import { Money } from './Money';
import { UnexpectedLineItemType } from './error';
/**
 * Order details for a request for audio access.
 */
export class AudioLineItem extends LineItem {
    constructor() {
        super(...arguments);
        this.type = LineItemType.Audio;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Identifies whether this order should retrieve speech to text for the audio segment id
     */
    )
], AudioLineItem.prototype, "estimate", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], AudioLineItem.prototype, "speechToTextFee", void 0);
export function assertIsAudioLineItem(lineItem, message) {
    if (!isAudioLineItem(lineItem)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedLineItemType(message !== null && message !== void 0 ? message : `Expected ${LineItemType.Audio} line item, but received ${lineItem.type} line item`);
    }
}
export function isAudioLineItem(lineItem) {
    return lineItem.type === LineItemType.Audio;
}
